/**
 * Este plugin hace una sobreescritura del layout 'admin' para todas las rutas que empiecen por '/admin/'.
 */

export default defineNuxtPlugin({
  name: 'admin-layout-override',
  setup() {
    const router = useRouter();

    router.beforeEach((to) => {
      // Verificar si la ruta empieza por '/admin'
      if (to.path.startsWith('/admin')) {
        // Aplicar el layout 'admin' a esta ruta
        to.meta.layout = 'admin';
      }
    });
  },
});
